import { Injectable } from '@angular/core';

/**
 * In-memory OAuth storage used to avoid persisting tokens in browser storage.
 */
@Injectable({
  providedIn: 'root',
})
export class InMemoryOAuthStorageService {
  /**
   * Internal token storage map.
   */
  private readonly storage = new Map<string, string>();

  /**
   * Returns a stored token value.
   *
   * @param key Storage key
   */
  public getItem(key: string): string | null {
    return this.storage.get(key) ?? null;
  }

  /**
   * Removes a stored token value.
   *
   * @param key Storage key
   */
  public removeItem(key: string): void {
    this.storage.delete(key);
  }

  /**
   * Stores a token value in memory.
   *
   * @param key Storage key
   * @param data Token value
   */
  public setItem(key: string, data: string): void {
    this.storage.set(key, data);
  }
}
